var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgGraphBills = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24562 16V18C5.24562 18.2652 5.35097 18.5196 5.53851 18.7071C5.72605 18.8946 5.9804 19 6.24562 19H21.2456C21.5108 19 21.7652 18.8946 21.9527 18.7071C22.1403 18.5196 22.2456 18.2652 22.2456 18V10C22.2456 9.73478 22.1403 9.48043 21.9527 9.29289C21.7652 9.10536 21.5108 9 21.2456 9H20.0006V10.8345C20.1376 11.0389 20.3229 11.2064 20.5401 11.3221C20.7572 11.4378 20.9995 11.4982 21.2456 11.498V16.5C20.8493 16.5022 20.4699 16.6613 20.1904 16.9423C19.911 17.2234 19.7541 17.6036 19.7541 18H7.74312C7.73787 17.6059 7.57782 17.2297 7.29754 16.9526C7.01727 16.6755 6.63925 16.5198 6.24512 16.519V16H5.24512H5.24562Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10C12.5 10.5304 12.2893 11.0391 11.9142 11.4142C11.5391 11.7893 11.0304 12 10.5 12C9.96957 12 9.46086 11.7893 9.08579 11.4142C8.71071 11.0391 8.5 10.5304 8.5 10C8.5 9.46957 8.71071 8.96086 9.08579 8.58579C9.46086 8.21071 9.96957 8 10.5 8C11.0304 8 11.5391 8.21071 11.9142 8.58579C12.2893 8.96086 12.5 9.46957 12.5 10Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5C2.73478 5 2.48043 5.10536 2.29289 5.29289C2.10536 5.48043 2 5.73478 2 6V14C2 14.2652 2.10536 14.5196 2.29289 14.7071C2.48043 14.8946 2.73478 15 3 15H18C18.2652 15 18.5196 14.8946 18.7071 14.7071C18.8946 14.5196 19 14.2652 19 14V6C19 5.73478 18.8946 5.48043 18.7071 5.29289C18.5196 5.10536 18.2652 5 18 5H3ZM4.499 6H16.5005C16.5009 6.39743 16.6591 6.77845 16.9402 7.05934C17.2214 7.34022 17.6026 7.498 18 7.498V12.5C17.6036 12.502 17.2241 12.6609 16.9445 12.942C16.665 13.2232 16.5082 13.6036 16.5085 14H4.498C4.49301 13.6058 4.33304 13.2295 4.05271 12.9523C3.77238 12.6752 3.39421 12.5195 3 12.519V7.5C3.19694 7.5 3.39194 7.46119 3.57387 7.3858C3.75581 7.31041 3.9211 7.1999 4.06031 7.0606C4.19951 6.9213 4.30991 6.75593 4.38518 6.57395C4.46046 6.39197 4.49913 6.19694 4.499 6Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGraphBills, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/GraphBills.665d8637.svg";
export { ForwardRef as ReactComponent };